module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"url":"Url","trafic":"Traffic","%Traffic":"% Traffic","export":"Export"},"fr":{"url":"Url","trafic":"Trafic","%Trafic":"% Trafic","export":"Exporter"},"de":{"url":"URL","trafic":"Verkehr","%Trafic":"% Verkehr","export":"Exporteur"}}')
  delete Component.options._Ctor
}
